import script from "./CategoryCardModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryCardModal.vue?vue&type=script&setup=true&lang=js"

import "./CategoryCardModal.vue?vue&type=style&index=0&id=56809e1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56809e1e"]])

export default __exports__